import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
width: 100%;
height: 100%;
text-align: center;
`

const PDFViewer = ({fileUrl}) => {
  return (
    <Container>
      <iframe src={fileUrl} width="800" height="480" allow="autoplay"></iframe>
    </Container>
  )
}

export default PDFViewer